import { graphql } from 'gatsby';
import { Anchor } from '@twilio-paste/anchor';
import { Card } from '@twilio-paste/card';
import { Heading } from '@twilio-paste/heading';
import { Text } from '@twilio-paste/text';
import { UnorderedList, ListItem } from '@twilio-paste/list';
import { SiteLink } from "../../../../src/components/SiteLink.tsx";
import { Breadcrumb, BreadcrumbItem } from "../../../../src/components/breadcrumb";
import { ComponentOverviewTable } from "../../../../src/components/component-overview-table";
import { SidebarCategoryRoutes } from "../../../../src/constants";
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { StatusLegend } from "../../../../src/components/StatusLegend";
import * as React from 'react';
export default {
  graphql,
  Anchor,
  Card,
  Heading,
  Text,
  UnorderedList,
  ListItem,
  SiteLink,
  Breadcrumb,
  BreadcrumbItem,
  ComponentOverviewTable,
  SidebarCategoryRoutes,
  Callout,
  CalloutTitle,
  CalloutText,
  StatusLegend,
  React
};